const BASE_HOME_ROUTE = '/home';

export default function useHomeTo() {
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '';

  // Unlike the old /classes a student can navigate so a number of subroutes
  // within /home while staying within the same view. Therefore calculating
  // the exact link we should use in nav items is tricky. So instead we link to `''`
  // So that the user always stays where they are if they are within /home.
  return pathname.startsWith(BASE_HOME_ROUTE) ? '' : BASE_HOME_ROUTE;
}
